/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Scope_BodyInputs */

const en_svc_rag_scope_body = /** @type {(inputs: Svc_Rag_Scope_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A language model on its own answers from general training data. RAG makes it search your approved material first and answer from that, so the answer is specific to your business and can be checked.`)
};

const lv_svc_rag_scope_body = /** @type {(inputs: Svc_Rag_Scope_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valodas modelis viens pats atbild no vispārīgiem apmācības datiem. RAG liek tam vispirms meklēt Jūsu apstiprinātajos materiālos un atbildēt no tiem, tāpēc atbilde attiecas tieši uz Jūsu uzņēmumu un to var pārbaudīt.`)
};

/**
* | output |
* | --- |
* | "A language model on its own answers from general training data. RAG makes it search your approved material first and answer from that, so the answer is speci..." |
*
* @param {Svc_Rag_Scope_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_scope_body = /** @type {((inputs?: Svc_Rag_Scope_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Scope_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_scope_body(inputs)
	return en_svc_rag_scope_body(inputs)
});